import { createSlice } from "@reduxjs/toolkit";
import {
  normalizeEpicSearchPayload,
} from "./searchSliceUtils";
import { createValuePreparer } from "./reduxUtils";

const initialState = {
  searchEpic: [],
};

const search = createSlice({
  name: "epic",
  initialState,
  reducers: {
    searchCard: {
      prepare: createValuePreparer("searchEpic"),
      reducer(state, action) {
        state.searchEpic = normalizeEpicSearchPayload(
          action.payload.searchEpic
        );
      },
    },
  },
});

export const { searchCard } = search.actions;

export default search.reducer;
